export function formatNumber(number) {
  if (number === null || isNaN(number)) {
    return "0.00"; // Default value for null or invalid numbers
  }

  return number
    .toFixed(2) // Ensure two decimal places
    .replace(/\d(?=(\d{3})+\.)/g, "$&,"); // Add commas for thousands
}

export function formatAmount(num) {
  if (typeof num !== 'number' || isNaN(num)) {
    return 'Invalid number';
  }
  if (num >= 1e9) {
    return (num / 1e9).toFixed(1).replace(/\.0$/, "") + "B Challenge";
  } else if (num >= 1e6) {
    return (num / 1e6).toFixed(1).replace(/\.0$/, "") + "M Challenge";
  } else if (num >= 1e3) {
    return (num / 1e3).toFixed(1).replace(/\.0$/, "") + "K Challenge";
  }
  return num.toString();
}

// Helper function to check if GOLD market is open (COMEX example, ET time)
export const isGoldMarketOpen = () => {
  const now = new Date();
  const day = now.getUTCDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6
  const hour = now.getUTCHours(); // UTC time
  const minute = now.getUTCMinutes();

  // COMEX gold trading hours in UTC (6 PM Sunday - 5 PM Friday ET)
  // ET is UTC-5 normally, UTC-4 in DST
  // For simplicity, we’ll assume UTC-5 (adjust if needed)
  const utcHour = hour;

  // Exclude weekends: Saturday and Sunday UTC
  if (day === 6 || day === 0) return false;

  // Simple open hours check (Monday to Friday, 1 PM - 10 PM UTC for COMEX)
  // You can adjust exact hours as needed
  if (utcHour >= 13 && utcHour <= 22) return true;

  return false;
};

export const parseMonthAndYear = (selectedMonth, selectedYear) => {
  // Example formats:
  // "January - 2026"
  // "September"
  // "October"

  if (selectedMonth.includes("-")) {
    const [month, year] = selectedMonth.split("-").map(v => v.trim());
    return {
      month,
      year: Number(year),
    };
  }

  // If no year in the string, default to 2025
  return {
    month: selectedMonth,
    year: 2025,
  };
};
